import { z } from "zod";

//ContratoSchema

const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalDecimal = z.coerce.number().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
const optionalDate = z.coerce.date().nullable().optional();

export const ContratoSchema = z.object({
  IdContrato: z.number().int().default(0),
  Status: optionalNumber,
  NumeroContrato: z.string({ required_error: "O Número do Contrato é obrigatório" })
    .trim()
    .min(1, "O Número do Contrato é obrigatório") 
    .max(50, "Máximo de 50 caracteres"),
  Escopo: optionalString,
  DataDe: optionalDate,
  DataAte: optionalDate,
  IdCentroCusto: optionalNumber,
  IdFornecedor: optionalNumber,
  StatusPcmat: optionalNumber,
  StatusPcmso: optionalNumber,
  ValorContrato: optionalDecimal,
  ValorMedido: optionalDecimal,
  ValorRestante: optionalDecimal,
  ContratoAssinado: optionalNumber,
});

// ContratoForm
export type ContratoForm = z.infer<typeof ContratoSchema>;